import { Header } from "@/components/header/Header";
import { Hero } from "@/components/hero/Hero";
import { AboutSection } from "@/components/about/AboutSection";
import { StatsCounter } from "@/components/StatsCounter/StatsCounter";
import { FeatureBar } from "@/components/FeatureBar/FeatureBar";
import { MarqueeSection } from "@/components/MarqueeSection/MarqueeSection";
import { ProductScrollSection } from "@/components/ProductScrollSection/ProductScrollSection";
import { TrustedBrandsMarquee } from "@/components/TrustedBrandsMarquee/TrustedBrandsMarquee";
import { CatalogGallerySection } from "@/components/CatalogGallerySection/CatalogGallerySection";
import { ChapterStackSection } from "@/components/ChapterStackSection/ChapterStackSection";
import { TestimonialsSection } from "@/components/TestimonialsSection/TestimonialsSection";
import { ContactSection } from "@/components/ContactSection/ContactSection";
import { HandcraftedLuxury } from "@/components/HandcraftedLuxury/HandcraftedLuxury";
import CertificationsMarquee from "@/components/CertificationsMarquee/CertificationsMarquee";
import { CategoriesSection } from "@/components/categories/CategoriesSection";
import { SocialEmbedSection } from "@/components/SocialEmbedSection/SocialEmbedSection";


import { Footer } from "@/components/Footer/Footer";

export default function HomePage() {
  return (
    <main>
      <Header />
      <Hero />
      <TrustedBrandsMarquee />
      <AboutSection />
      <StatsCounter />


      <ProductScrollSection />
      <MarqueeSection />

      <CategoriesSection />
      <FeatureBar />

      <CatalogGallerySection />
      <CertificationsMarquee />
      <ChapterStackSection />
      <TestimonialsSection />
      <ContactSection />
      <HandcraftedLuxury />
      <SocialEmbedSection />
      <Footer />
    </main>
  );
}
